import { Tabs } from 'antd'
import { type FC } from 'react'
import UpcomingCourseList from './UpcomingCourseList'
import PastCourseList from './PastCourseList'
import { useUrlQuery } from '~/hooks/useUrlParams'

const DoctorCourses: FC = () => {
  const { queryValue, setQueryValue } = useUrlQuery({
    name: 'tab',
    defaultValue: 'upcoming-course'
  })

  return (
    <Tabs
      activeKey={queryValue.at(0)}
      items={[
        { key: 'upcoming-course', label: 'Upcoming events', children: <UpcomingCourseList /> },
        { key: 'past-course', label: 'Past events', children: <PastCourseList /> }
      ]}
      onChange={(key) => { setQueryValue(key) }}
    />
  )
}

export default DoctorCourses
